// BORRAR O COMENTAR ESTE ARCHIVO CUANDO SE TERMINEN DE PROBAR LOS WIDGETS
const LOREM_REPLY = ['Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.', 'Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'].join('\n\n')

const CHUNK_SIZE = 20
const SIMULATED_REPLY_DELAY_MS = 1500

function waitForSimulatedReply() {
    return new Promise((resolve) => {
        setTimeout(resolve, SIMULATED_REPLY_DELAY_MS)
    })
}

const KEYWORDS = [
    { phrase: '10 iniciales, 47 totales', exampleId: 'list10' },
    { phrase: '10 iniciales, 25 totales', exampleId: 'list10Long' },
    { phrase: '10 iniciales, 20 totales', exampleId: 'list10Medium' },
    { phrase: '10 iniciales, 12 totales', exampleId: 'list10Short' },
    { phrase: '20 iniciales, 47 totales', exampleId: 'list20' },
    { phrase: '5 iniciales, 47 totales', exampleId: 'longList' },
    { phrase: '5 iniciales, 21 totales', exampleId: 'list21' },
    { phrase: '5 iniciales, 20 totales', exampleId: 'list20Exact' },
    { phrase: '5 iniciales, 12 totales', exampleId: 'list12' },
    { phrase: '5 iniciales, 6 totales', exampleId: 'list6' },
    { phrase: '0 iniciales, 15 totales', exampleId: 'listInvalid' },
    { phrase: '10 iniciales, 47 totales', exampleId: 'list10' },
    { phrase: '10 iniciales, 25 totales', exampleId: 'list10Long' },
    { phrase: '10 iniciales, 20 totales', exampleId: 'list10Medium' },
    { phrase: '10 iniciales, 12 totales', exampleId: 'list10Short' },
    { phrase: '20 iniciales, 47 totales', exampleId: 'list20' },
    { phrase: '5 iniciales, 47 totales', exampleId: 'longList' },
    { phrase: '5 iniciales, 21 totales', exampleId: 'list21' },
    { phrase: '5 iniciales, 20 totales', exampleId: 'list20Exact' },
    { phrase: '5 iniciales, 12 totales', exampleId: 'list12' },
    { phrase: '5 iniciales, 6 totales', exampleId: 'list6' },
    { phrase: '0 iniciales, 15 totales', exampleId: 'listInvalid' },
    { phrase: 'planes de accion', exampleId: 'actionPlans' },
    { phrase: 'plan de accion', exampleId: 'actionPlans' },
    { phrase: 'auditorias', exampleId: 'audits' },
    { phrase: 'registros', exampleId: 'registers' },
    { phrase: 'sensores', exampleId: 'sensors' },
    { phrase: 'libreria', exampleId: 'library' },
    { phrase: 'con radio y botones', exampleId: 'camera' },
    { phrase: 'camara', exampleId: 'camera' },
    { phrase: 'tres botones', exampleId: 'buttons' },
    { phrase: 'incidencias', exampleId: 'incidents' },
    { phrase: 'tareas', exampleId: 'tasks' },
    { phrase: 'vacio', exampleId: 'empty' }
]

const DESCRIPTION_LINE = 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.'
const DESCRIPTION_DOT_COLORS = ['#054135', '#e08c43', '#aaaaaa']

function numberedRows(count, createRow) {
    const rows = []
    for (let index = 0; index < count; index += 1) {
        rows.push(createRow(index))
    }
    return rows
}

function descriptionFields(index) {
    return {
        description: DESCRIPTION_LINE,
        showDescriptionDot: true,
        descriptionDotColor: DESCRIPTION_DOT_COLORS[index % DESCRIPTION_DOT_COLORS.length]
    }
}

function checklistRows(exampleId, count, route, withReference) {
    return numberedRows(count, (index) => {
        const row = {
            id: exampleId + '-' + (index + 1),
            title: 'Título del checklist ' + (index + 1),
            route: route
        }
        if (withReference) {
            row.reference = '#' + (index + 1)
        }
        return Object.assign(row, descriptionFields(index))
    })
}

function taskCatalog(exampleId, count, visibleRows) {
    return {
        exampleId: exampleId,
        tool: 'tasks',
        title: 'Tareas',
        icon: 'menu-checklist',
        description: count + ' pendientes',
        route: '/checklist',
        visibleRows: visibleRows,
        rows: checklistRows(exampleId, count, '/checklist', false)
    }
}

const CATALOGS = {
    tasks: taskCatalog('tasks', 8, 5),
    longList: taskCatalog('longList', 47, 5),
    list10: taskCatalog('list10', 47, 10),
    list10Short: taskCatalog('list10Short', 12, 10),
    list10Medium: taskCatalog('list10Medium', 20, 10),
    list10Long: taskCatalog('list10Long', 25, 10),
    list20: taskCatalog('list20', 47, 20),
    list12: taskCatalog('list12', 12, 5),
    list20Exact: taskCatalog('list20Exact', 20, 5),
    list21: taskCatalog('list21', 21, 5),
    list6: taskCatalog('list6', 6, 5),
    listInvalid: taskCatalog('listInvalid', 15, 0),
    registers: {
        exampleId: 'registers',
        tool: 'registers',
        title: 'Registros',
        icon: 'menu-register',
        description: '18 en borrador',
        route: '/register',
        visibleRows: 5,
        rows: checklistRows('registers', 18, '/register', false)
    },
    audits: {
        exampleId: 'audits',
        tool: 'audits',
        title: 'Auditorías',
        icon: 'menu-audit',
        description: '3 este mes',
        route: '/audit',
        visibleRows: 5,
        rows: checklistRows('audits', 3, '/audit', true)
    },
    actionPlans: {
        exampleId: 'actionPlans',
        tool: 'actionPlans',
        title: 'Planes de acción',
        icon: 'menu-audit',
        description: '32 pendientes',
        route: '/action_plan/1',
        visibleRows: 5,
        rows: checklistRows('actionPlans', 32, '/action_plan/1', true)
    },
    sensors: {
        exampleId: 'sensors',
        tool: 'sensors',
        title: 'Sensores',
        icon: 'remote-control-line',
        description: '3 con alertas',
        route: '/sensor',
        visibleRows: 5,
        rows: [Object.assign({ id: 'sensor-1', title: 'nombre del sensor', value: '8,2 °C', showValueDot: true, valueDotColor: '#BD1F1E', route: '/sensor' }, descriptionFields(0)), Object.assign({ id: 'sensor-2', title: 'nombre del sensor', value: '3,1 °C', showValueDot: true, valueDotColor: '#E08C43', route: '/sensor' }, descriptionFields(1)), Object.assign({ id: 'sensor-3', title: 'nombre del sensor', value: '6,4 °C', showValueDot: true, valueDotColor: '#1D7672', route: '/sensor' }, descriptionFields(2))]
    },
    camera: {
        exampleId: 'camera',
        title: 'Cámara 3 fuera de rango',
        icon: 'menu-task',
        rows: [Object.assign({ id: 'camera-1', title: 'Sonda superior', value: '12,4 °C', showValueDot: true, valueDotColor: '#BD1F1E', showRadio: true }, descriptionFields(0)), Object.assign({ id: 'camera-2', title: 'Sonda inferior', value: '9,1 °C', showValueDot: true, valueDotColor: '#E08C43', showRadio: true }, descriptionFields(1))],
        buttons: [{ label: 'Confirmar' }, { label: 'Ahora no' }]
    },
    buttons: {
        exampleId: 'buttons',
        title: 'Título del widget',
        icon: 'menu-task',
        rows: [
            { id: 'op-1', title: 'Opción 1', value: '12,4 °C', showValueDot: true, valueDotColor: '#BD1F1E', showRadio: true },
            { id: 'op-2', title: 'Opción 2', value: '9,1 °C', showValueDot: true, valueDotColor: '#E08C43', showRadio: true },
            { id: 'op-3', title: 'Opción 3', value: '6,4 °C', showValueDot: true, valueDotColor: '#1D7672', showRadio: true }
        ],
        buttons: [{ label: 'Confirmar' }, { label: 'Ahora no' }, { label: 'Tercer botón' }]
    },
    library: {
        exampleId: 'library',
        tool: 'library',
        title: 'Librería',
        icon: 'menu-library',
        description: DESCRIPTION_LINE,
        route: '/library',
        visibleRows: 5,
        rows: [Object.assign({ id: 'library-1', title: 'Título del PDF. Ejemplo: Manual de APPCC', route: '/library' }, descriptionFields(0))]
    },
    incidents: {
        exampleId: 'incidents',
        tool: 'incidents',
        title: 'Incidencias',
        icon: 'menu-task',
        description: '3 abiertas',
        route: '/issues',
        visibleRows: 5,
        rows: checklistRows('incidents', 3, '/issues', true).map((row, index) => Object.assign({}, row, { descriptionDotColor: '#cd902f', title: 'Título del checklist ' + (index + 1) }))
    },
    empty: {
        exampleId: 'empty',
        tool: 'tasks',
        title: 'Tareas',
        icon: 'menu-checklist',
        description: '0 pendientes',
        route: '/checklist',
        visibleRows: 5,
        rows: [],
        emptyText: 'No hay tareas pendientes hoy',
        buttons: [{ label: 'Confirmar' }]
    }
}

function normalize(value) {
    return String(value || '')
        .toLocaleLowerCase('es')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
}

function matchExampleId(message) {
    const text = normalize(message)
    let match = null

    KEYWORDS.forEach((keyword) => {
        const index = text.indexOf(keyword.phrase)
        if (index === -1) {
            return
        }
        const isEarlier = !match || index < match.index
        const isLongerAtSameSpot = match && index === match.index && keyword.phrase.length > match.phrase.length
        if (isEarlier || isLongerAtSameSpot) {
            match = { index: index, phrase: keyword.phrase, exampleId: keyword.exampleId }
        }
    })

    return match ? match.exampleId : ''
}

function parseCursor(cursor) {
    const text = String(cursor || '')
    const separator = text.indexOf(':')
    if (separator <= 0) {
        return null
    }
    const exampleId = text.slice(0, separator)
    const offset = Number(text.slice(separator + 1))
    if (!exampleId || !Number.isFinite(offset) || offset < 0) {
        return null
    }
    return { exampleId: exampleId, offset: offset }
}

function buildWidget(catalog, offset) {
    const allRows = Array.isArray(catalog.rows) ? catalog.rows : []
    const total = allRows.length
    const start = offset > 0 ? offset : 0
    const rows = allRows.slice(start, start + CHUNK_SIZE)
    const nextStart = start + rows.length
    const widget = {
        id: catalog.exampleId + '-' + start,
        exampleId: catalog.exampleId,
        title: catalog.title,
        icon: catalog.icon || '',
        description: catalog.description || '',
        total: total,
        offset: start,
        rows: rows,
        nextCursor: nextStart < total ? catalog.exampleId + ':' + nextStart : null
    }

    if (catalog.tool) {
        widget.tool = catalog.tool
    }
    if (catalog.route) {
        widget.route = catalog.route
    }
    if (start > 0) {
        widget.visibleRows = CHUNK_SIZE
    } else if (catalog.visibleRows !== undefined) {
        widget.visibleRows = catalog.visibleRows
    }
    if (catalog.emptyText) {
        widget.emptyText = catalog.emptyText
    }
    if (Array.isArray(catalog.buttons)) {
        widget.buttons = catalog.buttons
    }
    return widget
}

const CLARIFICATION_REPLY = '¿Quieres que te revise esto?'

export function fetchAndyAgentsReplyMock(message) {
    return waitForSimulatedReply().then(() => {
        if (normalize(message).indexOf('aclaracion') !== -1) {
            return { text: CLARIFICATION_REPLY, canRate: false, widgets: [] }
        }

        const exampleId = matchExampleId(message)
        if (!exampleId || !CATALOGS[exampleId]) {
            return { text: LOREM_REPLY, canRate: true, widgets: [] }
        }

        return {
            text: '',
            canRate: true,
            widgets: [buildWidget(CATALOGS[exampleId], 0)]
        }
    })
}

export function fetchAndyAgentsWidgetNextMock(payload) {
    return waitForSimulatedReply().then(() => {
        const parsed = parseCursor(payload && payload.nextCursor)
        const catalog = parsed ? CATALOGS[parsed.exampleId] : null
        if (!catalog) {
            return { text: '', widgets: [] }
        }

        return {
            text: '',
            canRate: true,
            widgets: [buildWidget(catalog, parsed.offset)]
        }
    })
}
